"use strict";
/**
 * ContentProvider - 提供页面内容
 * 作为系统的入口点，协调各个组件
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentProvider = void 0;
const pageRenderer_1 = require("./pageRenderer");
class ContentProvider {
    constructor(options) {
        this.pageRenderer = new pageRenderer_1.PageRenderer(options.shortcodeRenderer);
    }
    /**
     * 从文本获取页面内容
     * @param text 文本内容
     * @returns 页面内容
     */
    getPageContent(text) {
        // 使用 PageRenderer 渲染内容
        const renderResult = this.pageRenderer.render(text);
        return {
            content: renderResult.content,
            summary: renderResult.summary,
            hasSummaryDivider: renderResult.hasSummaryDivider,
            frontmatter: renderResult.frontmatter
        };
    }
    /**
     * 从文件内容获取页面内容
     * @param filePath 文件路径
     * @param fileContent 文件内容
     * @returns 页面内容
     */
    getPageContentFromFile(filePath, fileContent) {
        return __awaiter(this, void 0, void 0, function* () {
            // 这里可以添加文件特定的处理逻辑
            return this.getPageContent(fileContent);
        });
    }
}
exports.ContentProvider = ContentProvider;
//# sourceMappingURL=contentProvider.js.map